import { render } from "./WizardStep2.vue?vue&type=template&id=1b7e184c"
import script from "./WizardStep2.vue?vue&type=script&lang=js"
export * from "./WizardStep2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/wizard/WizardStep2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b7e184c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b7e184c', __exports__)) {
    api.reload('1b7e184c', __exports__)
  }
  
  module.hot.accept("./WizardStep2.vue?vue&type=template&id=1b7e184c", () => {
    api.rerender('1b7e184c', render)
  })

}


export default __exports__